import api from '@/api'

const store = {
  state: {
    dataMenuGroupLimit: [],
    pagingMenuGroupLimit: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMenuGroupLimit: {
      byField: '',
      isDesc: false
    },
    filteringMenuGroupLimit: {
      outletCode: null,
      menuGroupCode: null,
      orderType: null
    }
  },

  mutations: {
    SET_MENUGROUPLIMIT: (state, payload) => {
      state.dataMenuGroupLimit = payload
    },
    SET_PAGING_PAGE_MENUGROUPLIMIT: (state, payload) => {
      state.pagingMenuGroupLimit.page = payload
    },
    SET_PAGING_TOTAL_MENUGROUPLIMIT: (state, payload) => {
      state.pagingMenuGroupLimit.total = payload
    },
    SET_SORTING_MENUGROUPLIMIT: (state, payload) => {
      state.sortingMenuGroupLimit = payload
    },
    SET_FILTERING_MENUGROUPLIMIT: (state, payload) => {
      state.filteringMenuGroupLimit = payload
    }
  },

  getters: {
    SortingMenuGroupLimit: state => state.sortingMenuGroupLimit,
    FilteringMenuGroupLimit: state => state.filteringMenuGroupLimit,
    PagingMenuGroupLimit: state => state.pagingMenuGroupLimit,
    GetAllMenuGroupLimit: state => state.dataMenuGroupLimit,
    GetOneMenuGroupLimit: state => id =>
      state.dataMenuGroupLimit.find(
        dataMenuGroupLimit => dataMenuGroupLimit.id === id
      )
  },

  actions: {
    async UpdateSortingMenuGroupLimit({ commit, dispatch }, payload) {
      commit('SET_SORTING_MENUGROUPLIMIT', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMenuGroupLimit')
    },

    async UpdateFilteringMenuGroupLimit({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_MENUGROUPLIMIT', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MENUGROUPLIMIT', 1)
      dispatch('GetAllMenuGroupLimit')
    },

    async GetAllMenuGroupLimit({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMenuGroupLimit(
          state.pagingMenuGroupLimit,
          state.sortingMenuGroupLimit,
          state.filteringMenuGroupLimit
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MENUGROUPLIMIT', result.headers['data-length'])
        commit('SET_MENUGROUPLIMIT', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMenuGroupLimit({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMenuGroupLimit(payload)
        dispatch('GetAllMenuGroupLimit')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMenuGroupLimit({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMenuGroupLimit(payload.id, payload)
        dispatch('GetAllMenuGroupLimit')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMenuGroupLimit({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMenuGroupLimit(id)
        dispatch('GetAllMenuGroupLimit')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
